import styled from 'styled-components';
import {typographyStyles} from '../../../../utils/styles';

const StyledBalanceDetails = styled.span`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.neutral_10};
  margin-right: 6px;

  .balance-value {
    ${typographyStyles.body.bold};
  }

  .ant-space-item {
    display: flex;
  }
`;

export { StyledBalanceDetails };
